import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import Paper from '@material-ui/core/Paper';
// import Typography from '@material-ui/core/Typography';
import SupportButton from './hoverButton';
import { Close, Chat } from '@material-ui/icons';
import SmallChatContainer from './smallChatContainer';
import theme from '../../theme';
import { useDispatch, useSelector } from 'react-redux';
import { getContactSupportListAction, addContactSupportRequestResponseAction } from '../../containers/contactSupport/action';

const useStyles = makeStyles((th) => ({
  supportContainer: {
    position: 'fixed',
    bottom: th.spacing(4),
    right: th.spacing(4),
    zIndex: 1300,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    fontFamily: theme.fontFamily.MARKPROBOOK
  },
  supportPopup: {
    marginBottom: th.spacing(1),
    padding: th.spacing(2),
    // maxWidth: 260,
    width: "380px",
    backgroundColor: th.palette.background.paper,
    boxShadow: th.shadows[3],
  },
}));
export default function ReviewSupportContainer() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useState({ current: "opened" })
  const dispatch = useDispatch();
  const contactSupportReducer = useSelector(state => state.contactSupportReducer)
  const getContactSupportListActionMethod = React.useCallback(
    (data) => dispatch(getContactSupportListAction(data)),
    [filters, dispatch]
  )
  const addContactSupportRequestResponseActionMethod = React.useCallback(
    (contact_id, data) => dispatch(
      addContactSupportRequestResponseAction(contact_id, data)
    )
    ,[filters, dispatch])

  const handleToggleSupport = (e) => {
    setOpen((prev) => !prev);
  };
  const handleChatResponseAction = React.useCallback((chatIdentifier, response) => {
    if (chatIdentifier && response) {
      addContactSupportRequestResponseActionMethod(chatIdentifier, { response: response, action: "close" })
      setFilters(s => ({ ...s, current: "closed" }))
    }
  }, [dispatch])
  const handleChatProcessingAction = React.useCallback((chatIdentifier, action) => {
    if (chatIdentifier && action) {
      console.log(dispatch(addContactSupportRequestResponseActionMethod(chatIdentifier, { action: action })))
      setFilters(s => ({ ...s, current: "processing" }))
    }
  }, [dispatch])

  React.useEffect(() => {
    if (open) {
      if (Object.hasOwn(filters, "current")) {
        const { current, ...rest } = filters
        getContactSupportListActionMethod({
          ...rest, status: current.toUpperCase()

        })
      }
    }
  }, [open, filters?.current])

  return (
    <div className={classes.supportContainer}>

      {contactSupportReducer?.error?.length ? (
        <div className={"error-container"}>
          {contactSupportReducer.error.map((each, index) => (
            <div key={index}>{each}</div>
          ))}
        </div>
      ) : null}
      {open && (

        <SmallChatContainer
          current={filters?.current}
          setCurrent={async (e) => setFilters(a => ({ ...a, current: e }))}
          showLoader={contactSupportReducer.loading}
          data={contactSupportReducer?.contactSupportList?.data || []}
          chatHeader="Support Requests"
          chatResponseAction={handleChatResponseAction}
          chatProcessingAction={handleChatProcessingAction}
        />

      )}
      <SupportButton
        onClick={handleToggleSupport}
        value={open ? <Close /> : <Chat />}
        startIcon={null}
      />
    </div>
  );
}
